import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type UpdateConfiguratorApplicationJourneyMutation,
    type UpdateConfiguratorApplicationJourneyMutationVariables,
    UpdateConfiguratorApplicationJourneyDocument,
} from '../../../api/mutations/updateConfiguratorApplicationJourney';
import { type CustomerKind } from '../../../api/types';
import { type ApplicantFormValues } from './ApplicantKYCPage/types';

const useUpdateConfiguratorApplication = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: ApplicantFormValues, customerKind: CustomerKind) => {
            const { data } = await apolloClient.mutate<
                UpdateConfiguratorApplicationJourneyMutation,
                UpdateConfiguratorApplicationJourneyMutationVariables
            >({
                mutation: UpdateConfiguratorApplicationJourneyDocument,
                variables: {
                    token,
                    configuration: values.configuration,
                    tradeInVehicle: values.tradeInVehicle.filter(({ isSelected }) => isSelected),
                    customerKind,
                    ...(values.financing && { financing: values.financing }),
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useUpdateConfiguratorApplication;
